<template>
  <div class="card">
    <div class="card-header border-0 bg-success p-2">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Lễ Tân</h3>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table">
        <thead>
          <th>Đơn Vị</th>
          <th>Họ Tên</th>
          <th>Định danh</th>
          <th>T.Khách</th>
          <th>T.Chức Năng</th>
          <th>T.Từ</th>
          <th>Vào</th>
          <th>Ra</th>
          <th></th>
        </thead>
        
          <tbody>
            <tr v-for="(job, inx) in jobs" :key="inx">
              <th class="py-1">
                {{ job.orgName}}
              </th>     
              <td  class="py-1">
                {{job.tenant}}
              </td>
              <td class="py-1" >
                {{job.tenantNational}}
              </td>
              <td  class="py-1">
                {{job.l1Id}}
              </td>
              <td class="py-1">
                {{job.l2Id}}
              </td>
              <td class="p-1 mb-0" width="5%" >
                <base-input input-classes="form-control" class="mb-0">
                  <select v-model.lazy="job.l3Id" >                          
                    <option v-for="the in thenoc" :value=the :key="the">{{ the }}</option>
                  </select>
                </base-input>
                <!--
                <base-input placeholder="T.Từ" v-model.lazy="job.l3Id"  input-classes="form-control-sm" class="mb-0"></base-input>
                -->
              </td>
              <td  class="py-1">
                {{formattime(job.in2Date)}}
              </td>
              <td class="py-1">
                {{formattime(job.out3Date)}}
              </td>  
              <td class="text-right py-1" >
                <base-button type="primary" v-if="permitl3" class="btn-sm" @click="checkinlayer3(job)">Vào</base-button>
                <base-button type="primary" v-if="permitl2" class="btn-sm" @click="checkoutlayer2(job)">Ra</base-button>
              </td>
              
            </tr>
        </tbody>
        
      </table>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'layer_2',
    props:{
      jobs: {
        type: Array
      },
      thenoc: {
        type: Array
      }
    },
    data() {
      return {
        }

    },
    methods: {
      checkinlayer3(job) {
        let data = {
          jobId: job._id,
          l3Id: job.l3Id,
          l3Proctor: this.$store.state.user.username
        }
        job.l3Proctor = this.$store.state.user.username
        job.status = 6
        job.in3Date = this.$moment()
        if(job.l3Id) {
          let card = { layer: 2, id: job.l3Id}
          this.$emit('deleteThe',card)
        }
        this.$store.dispatch('updatejob', job)
        this.$http.post('/jobs/in/layer3', data)
        
        
      },
      checkoutlayer2(job) {
        let data = {
          jobId: job._id
        }
        job.status = 8
        job.out2Date = this.$moment()
        if(job.l2Id){
          let card = { layer: 1, id:job.l2Id }
          this.$emit('addThe',card)
        }
        this.$store.dispatch('updatejob', job)
        this.$http.post('/jobs/out/layer2', data)
        
        
      },
      formattime(curdate) {
        if(curdate){
          return this.$moment.tz(curdate,"Asia/Ho_Chi_Minh").format("DD/MM/YYYY HH:mm")
        }
        return ''
      },
    },
    computed: {
       permitl1() {
          return this.$store.getters.permit_l1
        },
        permitl2() {
          return this.$store.getters.permit_l2
        },
        permitl3() {
          return this.$store.getters.permit_l3
        }
    },
    mounted() {

    },
    beforeDestroy() {

    },
  }
</script>
<style>
</style>
